<template>
  <div class="row footer mb-4">
    <div class="col-4">
      <img src="@/assets/logo_mix.png" />
    </div>
    <div class="col-8" style="text-align: left">
      <p class="footer_title">GUTS 理髮廳</p>
      <div v-if="data.loading" class="footer_subtitle">載入中...</div>
      <div v-else-if="data.branches.length > 0">
        <div v-for="branch in data.branches" :key="branch.id" class="branch-item">
          <p class="footer_subtitle">{{ branch.title }}</p>
          <p class="footer_address">{{ branch.address }}</p>
          <p class="footer_time">
            {{ formatTime(branch.openingHours.open) }} ~ {{ formatTime(branch.openingHours.close) }}
            <span v-if="!branch.isOpen" class="closed-tag">（休息中）</span>
          </p>
        </div>
      </div>
      <div v-else class="footer_subtitle">暫無分店資訊</div>
    </div>
    <div class="col-12">
      <img
        src="@/assets/facebook.png"
        @click="openUrl('https://www.facebook.com/gutsquickcut666')"
        style="width: 32px; margin-right: 4px"
      />
      <img
        src="@/assets/instagram.png"
        @click="openUrl('https://www.instagram.com/guts_barber_1987/')"
        style="width: 32px; margin-left: 4px"
      />
    </div>
    <div
      class="col-12 mt-3"
      style="text-align: left; font-size: 14px; color: #ffffff"
    >
      © {{ data.year }} GUTS. All rights reserved. v {{ data.version }}
    </div>
  </div>
</template>

<script>
import { reactive, onMounted } from "@vue/runtime-core";
import branchService from "@/services/branchService";

export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  setup() {
    const data = reactive({
      version: process.env.VUE_APP_VERSION,
      year: new Date().getFullYear(),
      branches: [],
      loading: false,
    });

    // 載入分店資訊
    const loadBranches = async () => {
      try {
        data.loading = true;
        const response = await branchService.getBranches();
        if (response.status === 200 && response.data) {
          data.branches = response.data;
        }
      } catch (error) {
        console.error("載入分店資訊失敗:", error);
      } finally {
        data.loading = false;
      }
    };

    // 格式化時間顯示
    const formatTime = (time) => {
      if (!time) return "";
      // 將 "07:00" 格式轉換為顯示格式
      return time.substring(0, 5);
    };

    onMounted(() => {
      loadBranches();
    });

    return { data, formatTime };
  },
  methods: {
    openUrl(url) {
      window.open(url);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.footer {
  width: 99%;
.branch-item {
  margin-bottom: 16px;
}
.branch-item:last-child {
  margin-bottom: 0;
}
.closed-tag {
  color: #ff6b6b;
  font-weight: 500;
}
  text-align: center;
  padding-left: 24px;
}
.footer_title {
  font-family: "Noto Sans TC", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  color: #eeae08;
  margin-bottom: 8px;
}
.footer_subtitle {
  font-family: "Noto Sans TC", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #eeae08;
  margin-bottom: 4px;
}
.footer_address {
  margin-top: 8px;
  font-family: "Noto Sans TC", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  margin-bottom: 8px;
  color: #ffffff;
}
.footer_time {
  font-family: "Noto Sans TC", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #ffffff;
}
</style>
